import {
  ActivitySetting,
  PeriodicSetting
} from '../app/main/account-setting/user-settings/notification-setting/notification-setting.component';

export class AuthorizeResponse {
    Authorization: string;
}

export class ResetPasswordForm {
    email: string | null;
}

export class ForgotPasswordResponse {
    message: string | null;
}

export class LoginForm {
    username: string | null;
    password: string | null;
}


export class UserPackage {
    name: string | null;
}

export class UserCompanyType {
    name: string | null;
}

export class UserCompany {

    id: number | null;
    name: string | null;

    package: UserPackage | null;
    companyType: UserCompanyType | null;

    advertiser: boolean | false;
    influencer: boolean | false;
    network: boolean | false;
    hasBilling: boolean| false;
    paymentId: number;
}

export class UserRole {
    name: string | null;
}

export class UserData {

    id: string | null;
    fullName: string | null;
    lastName: string | null;
    firstName: string | null;
    userTitle: string;
    phone: string;

    createdAt: Date | null;
    modifiedAt: Date | null;

    company: UserCompany | null;
    email: string | null;

    role: UserRole | null;
    image: string | null;
    isSsoUser: boolean;
    signupEntity: string;
    signupSource: string;
}

export enum UserRoleResponse {
  ADMINISTRATOR = 'Administrator',
  ANALYST = 'Achoo Analyst',
  USER = 'User'
}

export enum UserType {
    ADMIN = 'admin',
    ANALYST = 'analyst',
    ADVERTISER = 'advertiser',
    INFLUENCER = 'influencer',
    NETWORK = 'network',
    AGENCY = 'agency',
    GUEST = 'guest'
}

export class User {

    email: string | null;
    packageSub: string | null;
    admin: boolean | false;

    data: UserData | null;
    token: string | null;

    type: UserType | null;

    companyId: number | null;
    companyName: string | null;
    fullName: string | null;
    createdAt: Date | null;
    hasBilling: boolean;

    permissions: Array<string> | null;

    startDate?: Date;
}

declare namespace User {
    type UserType = 'a ' | 'b' | 'c';
}

export class UserProfile {
  companyName: string;
  password: string;
  confirmPassword: string;
  country: number;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  packageSub: string;
  phone: string;
  acceptTermService: boolean;
}

export class CustomLevelUsage {
  id: number;
  companyId: number;
  accountLevelsId: number;
  resultPerSearch: number;
  groupInfluencers: number;
  campaignsInfluencers: number;
  listeningMentions: number;
  measureExportReport: number;
  profileDemographics: number;
  exportReport: number;
  // subscription monthly values
  monthlyResultPerSearch: number;
  monthlyGroupInfluencers: number;
  monthlyCampaignsInfluencers: number;
  monthlyListeningMentions: number;
  monthlyMeasureExportReport: number;
  monthlyProfileDemographics: number;
  monthlyExportReport: number;
  monthlyPricing: string;
}

export class AccountLevelsUsage {
  id: number;
  compnayId: number;
  monthlyResultPerSearch: number;
  monthlyActiveInfluencers: number;
  // limitations
  limitations: AccountLevelsLimitations[] = [];
  // default usgage
  level: AccountLevels;
}

export class AccountLevelsLimitations {
  id: number;
  featureName: string;
  module: string;
  isActivated: boolean;
  activated: boolean;
}

export class AccountLevels {
  id: number;
  name: string | any;
  maxResultPerSearch: number;
  maxActiveInfluencers: number;
}

export class NewUser {
  accountId: number;
  password: string;
  confirmPassword: string;
  email: string;
  fullName: string;
  acceptTermService: boolean;
  plan_id?: string;
}

export enum BlockedReason {
  ACCOUNT_WALL = 'Account Wall'
}

export enum WallType {
  USAGE_LIMIT = 'Usage Limit',
  FEATURE_UNAVAILABLE = 'Feature Unavailable'
}

export enum WallName {
  CAMPAIGNS_DISABLED = 'Campaigns Disabled',
  GROUPS_DISABLED = 'Groups Disabled'
}

export enum AccountType {
  FREE = 'Free',
  BASIC = 'Basic',
  PREMIUM = 'Premium',
  ENTERPRISE = 'Enterprise'
}

export class InvalidAction {
  blocked: boolean;
  blockedReason: BlockedReason;
  wallType: WallType;
  wallName: string;
  limitEnabled: boolean;
  limitValue: number;
  limitDesired: number;
  accountLevel: AccountType;
  constructor(blocked: boolean, blockedReason: BlockedReason, wallType: WallType, wallName: string,
              limitEnabled: boolean, limitValue: number, limitDesired: number, accountLevel: AccountType) {
    if (blocked) {
      this.blocked = blocked;
      this.blockedReason = blockedReason;
      this.wallType = wallType;
      this.wallName = wallName;
    }
    if (limitEnabled) {
      this.limitEnabled = limitEnabled;
      this.limitValue = limitValue;
      this.limitDesired = limitDesired;
    }
    this.accountLevel = accountLevel;
  }
}

export class UserDetails {
  id: string | null;
  firstName: string | null;
  lastName: string| null;
  email: string | null;
  phone: string | null;
  image: string | null;
}

export class UserPassword {
  oldPassword: string | null;
  newPassWord: string;
  repeatNewPassword: string;
  constructor() {
    this.newPassWord = '';
    this.repeatNewPassword = '';
  }
}

export class UserDetailsFormData {
  value: UserDetails;
  valid: boolean;
}

export class UserPassWordFormData {
  value: UserPassword;
  valid: boolean;
}

export class NotificationSetting {
  activity: ActivitySetting;
  updates: PeriodicSetting;
  pendingAction: PeriodicSetting;
  promotionalEmails: PeriodicSetting;
}

export class UserSampleSetups {
  id: number;
  label: string;
}



// WEBPACK FOOTER //
// ./src/models/user.ts